export default __webpack_public_path__ + "static/media/0c942801a35cd3815fb24faf0916f63.9e1c794c.png";